// extracted by mini-css-extract-plugin
export default {"invalid":"FuncionEdit_invalid__KDlIA","spinnerContainer":"FuncionEdit_spinnerContainer__gMYiQ"};